import React from "react";

import SignInForm from "pages/App/SignInForm";
import IAM from "pages/App/IAM";
import Skeleton from "ui/Skeleton";

import useSignInPage from "hooks/useSignInPage";

import JCILogo from "assets/svg/jci-logo.svg";
import PolicyIcon from "assets/svg/tests.svg";

const SignInPage = () => {
  const { iamTypes, remoteIamEnabled, loading } = useSignInPage();

  if (loading) {
    return (
      <div className="app-loading-container">
        <Skeleton variant="rectangular" height="100%" width="100%" />
      </div>
    );
  }

  return (
    <div className="sign-in-container">
      <div className="sign-in-branding">
        <JCILogo />
      </div>
      <div className="sign-in-content">
        <SignInForm />
        <IAM iamTypes={iamTypes} remoteIamEnabled={remoteIamEnabled} />
      </div>
      <a
        className="privacyPolicy-link"
        href="https://www.johnsoncontrols.com/privacy"
        target="_blank"
        rel="noreferrer"
      >
        <PolicyIcon />
        Privacy Policy
      </a>
    </div>
  );
};

export default SignInPage;
